export default __webpack_public_path__ + "static/media/seeker.ec8e9fd9.png";